window.avatarFormatter = function(value, row) {
    let html = '';
    let alt = row.name;
    html += '<img src="'+value+'" class="rounded-circle me-2" height="22" alt="'+alt+'" loading="lazy" />';
    return html;
};
